export const resucitado = {
	nombre: "Resucitado",
	dia: "Domingo de Resurrección",
	nombrecompleto:
		"Venerable, Real y Muy Ilustre Archicofradía de la Santísima Resurrección de Nuestro Señor Jesucristo y Penitencia de Nuestro Padre Jesús Atado a la Columna y Azotes y María Santísima de las Lágrimas",
	sede: "Parroquia de San Antonio",
	pasos: 1,
	distancia: [765, 537],
	penitentes: 0,
	cargadores: 52,
	web: "http://www.diariodecadiz.es/semana_santa/Resucitado_0_1229577742.html",
	ida: [
		{ lng: -6.2962697, lat: 36.5339362 },
		{ lng: -6.2963274, lat: 36.533294 },
		{ lng: -6.2962657, lat: 36.5332455 },
		{ lng: -6.2964132, lat: 36.53296 },
		{ lng: -6.2967888, lat: 36.5325515 },
		{ lng: -6.2970473, lat: 36.5329554 },
		{ lng: -6.2971428, lat: 36.5330645 },
		{ lng: -6.2987246, lat: 36.5345633 },
		{ lng: -6.2989516, lat: 36.5343484 },
		{ lng: -6.2992931, lat: 36.5346267 },
		{ lng: -6.2993516, lat: 36.5345817 }
	],
	vuelta: [
		{ lng: -6.2993637, lat: 36.5345925 },
		{ lng: -6.2993073, lat: 36.5346399 },
		{ lng: -6.2994629, lat: 36.5347735 },
		{ lng: -6.2997875, lat: 36.5345365 },
		{ lng: -6.3005197, lat: 36.5337843 },
		{ lng: -6.3000181, lat: 36.5335903 },
		{ lng: -6.2993798, lat: 36.5342175 },
		{ lng: -6.2989774, lat: 36.5338834 },
		{ lng: -6.2984665, lat: 36.5343306 },
		{ lng: -6.2977034, lat: 36.5350699 },
		{ lng: -6.2966728, lat: 36.5346733 },
		{ lng: -6.2960029, lat: 36.5339664 },
		{ lng: -6.2962697, lat: 36.5339362 }
	],
	markers: [
		{
			name: "Salida",
			hora: "2018-04-01T16:30",
			latlng: [36.53458, -6.29936]
		}
	],
	itinerario: [
		[
			"Plaza San Antonio (Izq)",
			"Zaragoza",
			"Benjumeda (Izq)",
			"Torre (Izq)",
			"Cervantes (Drch)",
			"San Jose",
			"Ancha",
			"San Jose",
			"Plaza Mina",
			"Tinte",
			"Plaza San Francisco",
			"Rosario",
			"Beato Diego de Cádiz",
			"Valverde",
			"Novena (Drch)",
			"Ancha",
			"Plaza San Antonio (Izq)"
		]
	],
	mapConfig: {
		center: [36.5311, -6.29721],
		zoom: 17
	}
};



// WEBPACK FOOTER //
// ./src/data/procesiones/resucitado.js